(function () {
  const EMAIL_RE = /^\S+@\S+\.\S+$/;
  const MSG_INVALID = "Enter an email address like example@mysite.com.";
  const MSG_SUCCESS = "Thanks, we received your submission.";
  const VISIBLE = "footer-newsletter__feedback--visible";
  const SUCCESS_HIDE_MS = 5000;

  const successTimers = new WeakMap();

  function normalizeBase(url) {
    return String(url ?? "")
      .trim()
      .replace(/\/+$/, "");
  }

  function getParts(form) {
    return {
      input: form.querySelector('input[type="email"]'),
      errWrap: form.querySelector("[data-footer-newsletter-error]"),
      errLabel: form.querySelector("[data-footer-newsletter-error-label]"),
      okEl: form.querySelector("[data-footer-newsletter-success]"),
      okLabel: form.querySelector("[data-footer-newsletter-success-label]"),
      submitBtn:
        form.querySelector("[data-footer-newsletter-submit]") ||
        form.querySelector('button[type="submit"]'),
      btnDefault: form.querySelector("[data-footer-newsletter-btn-default]"),
      btnLoader: form.querySelector("[data-footer-newsletter-btn-loader]"),
    };
  }

  function clearSuccessTimer(form) {
    const t = successTimers.get(form);
    if (t != null) clearTimeout(t);
    successTimers.delete(form);
  }

  function hideMessages(form) {
    clearSuccessTimer(form);
    const p = getParts(form);
    if (p.errWrap) {
      p.errWrap.classList.remove(VISIBLE);
      p.errWrap.setAttribute("aria-hidden", "true");
      if (p.errLabel) p.errLabel.textContent = "";
    }
    if (p.okEl) {
      p.okEl.classList.remove(VISIBLE);
      p.okEl.setAttribute("aria-hidden", "true");
      if (p.okLabel) p.okLabel.textContent = "";
    }
  }

  function setSubmitLoading(form, loading) {
    const p = getParts(form);
    if (!p.submitBtn) return;
    p.submitBtn.disabled = loading;
    p.submitBtn.setAttribute("aria-busy", loading ? "true" : "false");
    if (p.btnDefault) {
      p.btnDefault.hidden = loading;
      p.btnDefault.setAttribute("aria-hidden", loading ? "true" : "false");
    }
    if (p.btnLoader) {
      p.btnLoader.hidden = !loading;
      p.btnLoader.setAttribute("aria-hidden", loading ? "false" : "true");
    }
  }

  function showError(form, text) {
    hideMessages(form);
    const p = getParts(form);
    if (p.errLabel) p.errLabel.textContent = text;
    if (p.errWrap) {
      p.errWrap.classList.add(VISIBLE);
      p.errWrap.setAttribute("aria-hidden", "false");
    }
  }

  function scheduleSuccessHide(form) {
    clearSuccessTimer(form);
    const p = getParts(form);
    const id = window.setTimeout(function () {
      successTimers.delete(form);
      if (p.okEl) {
        p.okEl.classList.remove(VISIBLE);
        p.okEl.setAttribute("aria-hidden", "true");
      }
      if (p.okLabel) p.okLabel.textContent = "";
    }, SUCCESS_HIDE_MS);
    successTimers.set(form, id);
  }

  function showSuccess(form, text) {
    hideMessages(form);
    const p = getParts(form);
    if (p.okLabel) p.okLabel.textContent = text;
    if (p.okEl) {
      p.okEl.classList.add(VISIBLE);
      p.okEl.setAttribute("aria-hidden", "false");
      p.okEl.focus();
    }
    scheduleSuccessHide(form);
  }

  document.addEventListener("input", function (e) {
    var target = e.target;
    if (!target || target.tagName !== "INPUT") return;
    if (target.type !== "email") return;
    var form = target.closest("[data-footer-newsletter-form]");
    if (!form) return;
    hideMessages(form);
    target.removeAttribute("aria-invalid");
    target.removeAttribute("aria-describedby");
  });

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target.closest("[data-footer-newsletter-form]");
      if (!form) return;

      e.preventDefault();

      var base = normalizeBase(form.dataset.apiBase);
      var p = getParts(form);
      var email = p.input ? p.input.value.trim() : "";

      hideMessages(form);

      if (!base) {
        showError(form, "Something went wrong. Please try again later.");
        return;
      }

      if (!EMAIL_RE.test(email)) {
        showError(form, MSG_INVALID);
        if (p.input) {
          p.input.setAttribute("aria-invalid", "true");
          if (p.errWrap && p.errWrap.id)
            p.input.setAttribute("aria-describedby", p.errWrap.id);
        }
        return;
      }

      if (p.input) {
        p.input.removeAttribute("aria-invalid");
        p.input.removeAttribute("aria-describedby");
      }

      setSubmitLoading(form, true);

      fetch(base + "/api/non-member-signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { res: res, data: data };
          });
        })
        .then(function (ref) {
          var res = ref.res;
          var data = ref.data;
          if (res.ok && data && data.success) {
            showSuccess(form, (data && data.message) || MSG_SUCCESS);
            if (p.input) p.input.value = "";
          } else {
            var fallback =
              res.status === 400
                ? MSG_INVALID
                : "Something went wrong. Please try again later.";
            showError(form, (data && data.message) || fallback);
          }
        })
        .catch(function () {
          showError(form, "Something went wrong. Please try again later.");
        })
        .finally(function () {
          setSubmitLoading(form, false);
        });
    },
    true
  );
})();
